import * as React from 'react'
import {
  ChipField,
  FunctionField,
  ReferenceArrayField,
  ReferenceArrayInput,
  ReferenceField,
  ReferenceInput,
  SelectArrayInput,
  SelectInput,
  SingleFieldList,
  TextField,
} from 'react-admin'
import { useCourseIds } from '../utils/useCourseIds'

export const CourseIdSelect = (props) => {
  const course_ids = useCourseIds()
  return (
    <CourseSelect {...props} filter={course_ids ? { id: course_ids } : null} />
  )
}

export const CourseSelect = (props) => (
  <ReferenceInput
    allowEmpty
    label="Course"
    source="course_id"
    sort={{ field: 'name', order: 'ASC' }}
    reference="courses"
    {...props}
  >
    <SelectInput optionText="name" />
  </ReferenceInput>
)

CourseSelect.defaultProps = {
  fullWidth: true,
  label: 'Course',
}

export const CoursesSelect = (props) => (
  <ReferenceArrayInput
    {...props}
    allowEmpty
    sort={{ field: 'name', order: 'ASC' }}
    label="Courses"
    source="course_ids"
    reference="courses"
  >
    <SelectArrayInput optionText="name" />
  </ReferenceArrayInput>
)

CoursesSelect.defaultProps = {
  fullWidth: true,
  label: 'Courses',
}

export const AssessmentSelect = (props) => (
  <ReferenceInput
    {...props}
    allowEmpty
    sort={{ field: 'name', order: 'ASC' }}
    label="Assessment"
    source="assessment_id"
    reference="assessments"
    perPage={100}
  >
    <SelectInput optionText="name" />
  </ReferenceInput>
)

AssessmentSelect.defaultProps = {
  fullWidth: true,
  label: 'Assessment',
}

export const AssignmentSelect = (props) => (
  <ReferenceInput
    {...props}
    fullWidth
    sort={{ field: 'name', order: 'ASC' }}
    label="Assignment"
    source="assignment_id"
    reference="assignments"
    perPage={100}
  >
    <SelectInput source="name" />
  </ReferenceInput>
)

AssignmentSelect.defaultProps = {
  fullWidth: true,
  label: 'Assignment',
}

export const ClassSelect = (props) => (
  <ReferenceInput
    {...props}
    allowEmpty
    sort={{ field: 'name', order: 'ASC' }}
    label="Class"
    source="student_group_id"
    reference="student_groups"
    perPage={100}
  >
    <SelectInput optionText="name" />
  </ReferenceInput>
)

ClassSelect.defaultProps = {
  fullWidth: true,
  label: 'Class',
}

export const EventSelect = (props) => (
  <ReferenceInput
    {...props}
    allowEmpty
    sort={{ field: 'name', order: 'ASC' }}
    label="Event"
    source="event_id"
    reference="events"
    perPage={100}
  >
    <SelectInput optionText="name" />
  </ReferenceInput>
)

EventSelect.defaultProps = {
  fullWidth: true,
  label: 'Event',
}

export const StudentSelect = (props) => (
  <ReferenceInput
    {...props}
    allowEmpty
    sort={{ field: 'last_name', order: 'ASC' }}
    source="student_id"
    reference="students"
    perPage={100}
  >
    <SelectInput optionText={getFullName} />
  </ReferenceInput>
)

StudentSelect.defaultProps = {
  fullWidth: true,
  label: 'Students',
}

export const StudentGroupSelect = (props) => (
  <ReferenceInput
    {...props}
    sort={{ field: 'name', order: 'ASC' }}
    source="student_group_id"
    reference="student_groups"
    perPage={100}
  >
    <SelectInput source="name" />
  </ReferenceInput>
)

StudentGroupSelect.defaultProps = {
  fullWidth: true,
  label: 'Class',
}

export const StudentGroupField = (props) => (
  <ReferenceField
    {...props}
    source="student_group_id"
    reference="student_groups"
  >
    <TextField source="name" />
  </ReferenceField>
)

StudentGroupField.defaultProps = {
  fullWidth: true,
  addLabel: true,
  label: 'Class',
}

export const CourseField = (props) => (
  <ReferenceField {...props} source="course_id" reference="courses">
    <TextField source="name" />
  </ReferenceField>
)

CourseField.defaultProps = {
  fullWidth: true,
  addLabel: true,
  label: 'Course',
}

export const CoursesField = (props) => (
  <ReferenceArrayField {...props} source="course_ids" reference="courses">
    <SingleFieldList>
      <ChipField source="name" />
    </SingleFieldList>
  </ReferenceArrayField>
)

CoursesField.defaultProps = {
  fullWidth: true,
  label: 'Courses',
  addLabel: true,
}

export const EventField = (props) => (
  <ReferenceField {...props} source="event_id" reference="events">
    <TextField source="name" />
  </ReferenceField>
)

EventField.defaultProps = {
  fullWidth: true,
  addLabel: true,
  label: 'Event',
}

export const AssessmentField = (props) => (
  <ReferenceField {...props} source="assessment_id" reference="assessments">
    <TextField source="name" />
  </ReferenceField>
)

AssessmentField.defaultProps = {
  fullWidth: true,
  addLabel: true,
  label: 'Assessment',
}

export const StudentField = (props) => (
  <ReferenceField {...props} source="student_id" reference="students">
    <FullNameField />
  </ReferenceField>
)

StudentField.defaultProps = {
  fullWidth: true,
  addLabel: true,
  label: 'Student',
}

export const AssignmentField = (props) => (
  <ReferenceField {...props} source="assignment_id" reference="assignments">
    <TextField source="name" />
  </ReferenceField>
)

AssignmentField.defaultProps = {
  fullWidth: true,
  addLabel: true,
  label: 'Assignment',
}

export const FullNameField = (props) => (
  <FunctionField {...props} render={getFullName} />
)

export const getFullName = (s) =>
  s ? `${s.last_name}, ${s.first_name} ${s.middle_initial || 'X'}` : ''

FullNameField.defaultProps = {
  fullWidth: true,
  addLabel: true,
  label: 'Name',
}

export const ArchivedSelect = (props) => (
  <SelectInput
    {...props}
    source="archived_at"
    choices={[
      { id: 0, name: 'No' },
      { id: 1, name: 'Yes' },
    ]}
  />
)

ArchivedSelect.defaultProps = {
  alwaysOn: true,
  addLabel: true,
  defaultValue: 0,
  allowEmpty: false,
  label: 'Show Archived',
}
